<template>
  <component :is="type" v-bind="linkProps(to)" tabindex="0" @click.native="handleClick">
    <slot />
  </component>
</template>

<script>
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
// import { isExternal } from '@/utils/validate'

export default {
  props: {
    to: {
      type: String,
      required: true,
    },
    // When true, clicking this link while already on its route will
    // force the page to refresh (re-fetch data) instead of no-op'ing.
    refreshOnActiveClick: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isExternal() {
      return isExternal(this.to)
    },
    type() {
      if (this.isExternal) {
        return 'a'
      }
      return 'router-link'
    },
    isActive() {
      return !this.isExternal && this.$route.path === this.to
    },
  },
  methods: {
    linkProps(to) {
      if (this.isExternal) {
        return {
          href: to,
          target: '_blank',
          rel: 'noopener',
        }
      }
      return {
        to: to,
      }
    },
    handleClick(event) {
      if (!this.refreshOnActiveClick || !this.isActive) {
        return
      }
      // Preserve browser defaults for modifier-key clicks (open in new tab, etc).
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return
      }
      event.preventDefault()
      this.$store.dispatch('app/bumpRouteRefreshToken')
    },
  },
}
</script>
